import {URLS} from "@/api/config";
import {AxiosResponse} from "axios";
import {axiosBase} from "@/api/axios-base";
import {IBuyoutBasicInfo} from "@/components/buyoutDetail/config";

export const fetchBuyoutBasicInfo = async(buyoutId:string): Promise<AxiosResponse<IBuyoutBasicInfo>> => {
    return axiosBase.get(URLS.buyoutBasicInfo(buyoutId))
}